import { store } from 'store/index'

/**
 * Права текущего пользователя.
 *
 * Приходят при входе (`users_permissions`) и живут в redux вместе с остальным
 * аккаунтом. Ответ логина отдаёт их массивом объектов `{ value, permission_id }`.
 */
export function accountPermissions(account) {
	const source = account || store.getState().account

	if (!source || !Array.isArray(source.permissions)) {
		return []
	}

	return source.permissions
}

/**
 * Есть ли право.
 *
 * Владельцу заведения не отказываем: в кабинете он может всё, ровно как в
 * серверном middleware `permissions`.
 */
export function hasPermission(value, account) {
	if (!value) {
		return true
	}

	const source = account || store.getState().account

	if (source && source.role === 'ROLE_OWNER') {
		return true
	}

	const permissions = accountPermissions(source)

	for (let i = 0; i < permissions.length; i++) {
		if (permissions[i].value === value) {
			return true
		}
	}

	return false
}
